<script lang="ts" context="module">

    type LogEntry = {
        message: string;
    }

    const messagesFactoriesMap = {
        player_enter: createPlayerEnterEntry,
        player_leave: createPlayerLeaveEntry,
    };

    function createPlayerEnterEntry(event: RealTimeEvent): LogEntry {
        return {
            message: `🙋🏻 <span class="fw-bold">${event.data.player.name}</span> ha entrado en la sala.`,
        };
    }

    function createPlayerLeaveEntry(event: RealTimeEvent): LogEntry {
        return {
            message: `❌ <span class="fw-bold">${event.data.player.name}</span> ha salido de la sala.`,
        };
    }

</script>

<script lang="ts">
    
    import { onDestroy } from "svelte";
    import type { RealTimeEvent } from "../../global";
    import { eventsChannelsFactory } from "../../Services";
    import type { EventsChannel } from "../../Services/EventsChannel";
    import PlayerPill from "../Shared/PlayerPill.svelte";    

    export let roomId: string;
    export let limit = 5;

    let log: LogEntry[] = [];
    let roomChannel: EventsChannel;

    $: setupRoom(roomId);

    onDestroy(() => roomChannel?.destroy());

    function setupRoom(roomId: string): void {
        roomChannel?.destroy();
        roomChannel = eventsChannelsFactory.createEventsChannel(`room.${roomId}`);
        roomChannel.on('*', onRoomEvent);
    }

    function onRoomEvent(event: RealTimeEvent): void {
        const lastSegment = event.name.substring(event.name.lastIndexOf('.') + 1);
        if (!(lastSegment in messagesFactoriesMap)) {
            return;
        }
        const logEntry = messagesFactoriesMap[lastSegment](event);
        log.push(logEntry);
        if (log.length > limit) {
            log.splice(0, log.length - limit);
        }
        log = log;
    }

</script>

<div class="room-log">
    {#each log as entry (entry)}
        <div class="entry">{@html entry.message}</div>
    {/each}
</div>
